import styled from 'styled-components'
import ApyButton from 'views/Farms/components/FarmCard/ApyButton'
import BigNumber from 'bignumber.js'
import { BASE_ADD_LIQUIDITY_URL } from 'config'
import getLiquidityUrlPathParts from 'utils/getLiquidityUrlPathParts'
import { Skeleton } from '@pancakeswap/uikit'
import { useActiveChainId } from 'hooks/useActiveChainId'

export interface ApyProps {
   children?: import('react').ReactNode; value: string
  multiplier: string
  pid: number
  lpLabel: string
  lpSymbol: string
  lpRewardsApr: number
  lpTokenPrice: BigNumber
  tokenAddress?: string
  quoteTokenAddress?: string
  cakePrice: BigNumber
  originalValue: number
  hideButton?: boolean
  strikethrough?: boolean
  useTooltipText?: boolean
  boosted?: boolean
}

const Container = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};

  button {
    width: 20px;
    height: 20px;

    svg {
      path {
        fill: ${({ theme }) => theme.colors.textSubtle};
      }
    }
  }
`

const AprWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  min-width: 60px;
  text-align: left;
`

const Apy: React.FC<React.PropsWithChildren<ApyProps>> = ({
  value,
  pid,
  lpLabel,
  lpSymbol,
  lpTokenPrice,
  multiplier,
  tokenAddress,
  quoteTokenAddress,
  cakePrice,
  originalValue,
  hideButton = false,
  strikethrough,
  lpRewardsApr,
  useTooltipText = true,
  boosted,
}) => {
  const { chainId } = useActiveChainId()
  const liquidityUrlPathParts = getLiquidityUrlPathParts({ quoteTokenAddress, tokenAddress, chainId })
  const addLiquidityUrl = `${BASE_ADD_LIQUIDITY_URL}/${liquidityUrlPathParts}`

  // Define a threshold for extremely high values
  const APY_THRESHOLD = 100000 // Adjust threshold as needed

  // Check for invalid or large APY values
  const displayValue =
    !Number.isFinite(originalValue) || originalValue > APY_THRESHOLD || originalValue < 0 ? '∞' : `${originalValue}%`

  return (
    <Container>
      {originalValue ? (
        <ApyButton
          variant={hideButton ? 'text' : 'text-and-button'}
          pid={pid}
          lpSymbol={lpSymbol}
          lpLabel={lpLabel}
          lpTokenPrice={lpTokenPrice}
          multiplier={multiplier}
          cakePrice={cakePrice}
          apr={originalValue > APY_THRESHOLD ? 0 : originalValue}
          displayApr={displayValue}
          lpRewardsApr={lpRewardsApr}
          addLiquidityUrl={addLiquidityUrl}
          strikethrough={strikethrough}
          useTooltipText={useTooltipText}
          hideButton={hideButton}
          boosted={boosted}
        />
      ) : (
        <AprWrapper>
          <Skeleton width={60} />
        </AprWrapper>
      )}
    </Container>
  )
}

export default Apy
